import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function Card({ title, icon, link, description }) {
  return (
    <Link to={link} className="block group">
      <div className="bg-white rounded-2xl p-6 border border-gray-100/90 shadow-xs hover:shadow-md hover:border-purple-200 transition-all duration-300 transform hover:-translate-y-1 h-full flex flex-col justify-between">
        <div>
          <div className="w-12 h-12 rounded-2xl bg-purple-50 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-purple-100 transition-all">
            {icon}
          </div>

          <h3 className="text-base font-bold text-gray-900 group-hover:text-purple-700 transition-colors mb-1.5 leading-snug">
            {title}
          </h3>

          {description && (
            <p className="text-xs text-gray-500 leading-relaxed line-clamp-2">
              {description}
            </p>
          )}
        </div>

        <div className="mt-4 pt-3 border-t border-gray-100 flex items-center text-xs font-bold text-purple-600 group-hover:text-purple-700">
          <span>Explore</span>
          <ArrowRight
            size={14}
            className="ml-1.5 group-hover:translate-x-1 transition-transform"
          />
        </div>
      </div>
    </Link>
  );
}

export default Card;
